import { ClientUsersClient } from '@src/clientUser/manage/ClientUsersClient';
import { useQuery } from '@tanstack/react-query';

export const useClientUsers = ({ clientId }: { clientId: string }) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ['clientUsers.findForClient', clientId],
    queryFn: () => ClientUsersClient.findAllForClient({ clientId }),
  });

  return {
    clientUsers: data ?? [],
    isLoading,
    refreshClientUsers: refetch,
  };
};
